export const orderPromotionReducer = (state = [], action) => {
    switch (action.type) {
        case 'SET_ORDER_PROMOTIONS':
            return action.payload
        case 'RESET_ORDER_PROMOTIONS':
            return []
        default:
            return state
    }
};